/**
 * The four legal routes: /terms, /privacy, /host-agreement, /guest-agreement.
 *
 * One page component serves all four. It is given a slug by the route in
 * src/App.js, looks the document up in src/content/legal, and hands it to
 * the shared renderer. A fifth document needs a data file and a route, and
 * nothing here.
 */

import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import Legal from '../components/Legal';
import { findDocument } from '../content/legal';

const PageLegal = ({ slug }) => {
  const doc = findDocument(slug);

  // Unreachable while every route below passes a slug that exists. It is
  // here so a typo in a new route sends the reader home instead of
  // crashing the page. Task 21 replaces this with a real 404.
  if (!doc) return <Redirect to="/" />;

  return <Legal doc={doc} />;
};

PageLegal.propTypes = {
  slug: PropTypes.string.isRequired
};

export default PageLegal;
